import { render } from "./NutzerModalSperren.pug?vue&type=template&id=4e87aa18&lang=pug"
import script from "./NutzerModalSperren.js?vue&type=script&lang=js"
export * from "./NutzerModalSperren.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__